<script lang="ts">
  type Props = {
    placeholder?: string;
    value: string;
    onchange: (value: string) => void;
  };

  const { placeholder = 'Search', value, onchange }: Props = $props();
</script>

<div class="relative">
  <div class="absolute left-2 top-1/2 -translate-y-1/2 w-5 aspect-square text-stone"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search-icon lucide-search"><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg></div>
  <input name="search" class="!p-2.5 !pl-8 text-[.9rem]" type="text" {placeholder} {value} oninput={(e) => onchange(e.currentTarget.value)} />
</div>